/**
 * @module User
 */
import { getField, updateField } from 'vuex-map-fields';
import { mixin } from '../../helpers/helper'

export default {
	mixins: [mixin],
	namespaced: true,
	state: {
		userData: [],
		myErrors: [],
		errorMsg: '',
		stepLogin: 0,
		rolesAdmitted: ['access_token', 'ur_part', 'ur_modulo', 'ur_risorsa', 'ur_deadline', 'ur_sidebar', 'ur_user_id', 'ur_email', 'ur_type'],
	},
	getters: {
		getField,
	},
	mutations: {
		updateField,
		userDataSet: function (state, data) {
			state.userData = data;
		},

		stepLoadingLoginSet: function (state, data) {
			state.stepLogin = data.step;
			state.errorMsg = data.msg;
		}
	},

	actions: {
		/*        destroyToken: function (state) {
								for (var i = 0; i < state.state.rolesAdmitted.length; i++) {
										localStorage.removeItem(state.state.rolesAdmitted[i]);
								}
						},*/

		/*        redirectToLogin: function () {
								window.location.href = '/login';
						},*/

		/*     getUserData: function (state) {
						 axios.get('/api/v1/user')
								 .then(function (response) {
										 state.commit('userDataSet', response.data);
								 })
								 .catch(function (error) {
										 state.dispatch('destroyToken');
										 state.dispatch('redirectToLogin');
								 })
				 },*/

		/*        logout: function (state) {
								axios.get('/api/v1/user/logout')
										.then(function (response) {
												state.dispatch('destroyToken');
												state.dispatch('redirectToLogin');
										});
						},*/

		/*        checkLogin: function (state, data) {
								state.commit('stepLoadingLoginSet', {step: 1, msg: ''});
							//  state.dispatch('checkWPLogin', data); // check on Wordpress
								 state.dispatch('checkTeamMember', data);
						},*/

		/* checkTeamMember: function (state, data) {
				 state.dispatch('destroyToken');
				 axios.post('/oauth/token', {
						 username: data.email,
						 password: data.password,
						 client_id: 2,
						 client_secret: 'lZxWNLjGz7eHmc0Ner4ILkQDj0y5a6Y8Tolz8r7i',
						 grant_type: 'password'
				 })
						 .then(function (response) {
								 localStorage.setItem("access_token", response.data.access_token);
								 axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;
								 axios.get('api/v1/user/checkTypeMember')
										 .then(function (response) {
												 if (response.data.type === 99 || response.data.type === 98 || response.data.force === 1 ) {
														 window.location.href = '/login_cr'; // Avoid WordPress
												 } else {
														 state.dispatch('checkWPLogin', data); // check on Wordpress
												 }
										 })

						 })
						 .catch(function (error) {
								 state.dispatch('checkWPLogin', data);
						 })

		 },*/
		/*       checkPassportLogin: function (state, data) {
							 state.dispatch('destroyToken');
							 axios.post('/oauth/token', {
									 username: data.email,
									 password: data.password,
									 client_id: 2,
									 client_secret: 'lZxWNLjGz7eHmc0Ner4ILkQDj0y5a6Y8Tolz8r7i',
									 grant_type: 'password'
							 })
									 .then(function (response) {
											 localStorage.setItem("access_token", response.data.access_token);
											 window.location.href = '/login_cr';
											 //state.dispatch('checkWPLogin', data);
									 })
									 .catch(function (error) {
	 
									 })
					 },*/

		/*  checkWPLogin: function (state, data) {
					axios.post('/api/v1/wpauth', {
							email: data.email,
							password: data.password,
					})
							.then(function (response) {
									if (response.data !== false) {
											state.dispatch('registerUser', {userData: data, restOfData: response.data});
									} else {
											state.commit('stepLoadingLoginSet', {step: 0, msg: 'Ooops! Email o Password errati.'});
									}
							})
							.catch(function (error) {
									console.log(error);
									state.commit('stepLoadingLoginSet', {step: 0, msg: 'Ooops! Email o Password errati.'});

							})
			},*/

		/*        registerUser: function (state, data) {
								axios.post('api/v1/user/register', data)
										.then(function (response) {
												if (response.data.result === false) {
														state.commit('stepLoadingLoginSet', {
																step: 0,
																msg: 'Ooops! E\' probabile che il tuo pacchetto sia scaduto.'
														});
												} else {
														state.dispatch('checkPassportLogin', data.userData);
												}
										})
										.catch(function (error) { })
						},*/

		/*        checkErrorMessage: function (state, error) {
								if (error.status == 401) {
										state.dispatch('destroyToken');
										state.dispatch('redirectToLogin');
								}
						},*/

		/*  redirectUsingRole: function ( ) {

					let path = '';

					switch (parseInt(localStorage.getItem('ur_type'))) {
							case 98:
									path = '/adm/coach';
									break;
							default:
									path = '/dashboard';
									break;
					}
				 window.location.href = path;
			},*/

		/*     getUserRole: function (state) {
						 let self = this;
						 axios.get('/api/v1/user/checkRole')
								 .then(function (response) {
										 localStorage.setItem("ur_part", JSON.stringify(response.data.part));
										 localStorage.setItem("ur_modulo", JSON.stringify(response.data.modulo));
										 localStorage.setItem("ur_risorsa", JSON.stringify(response.data.risorsa));
										 localStorage.setItem("ur_sidebar", JSON.stringify(response.data.sidebar));
										 localStorage.setItem("ur_deadline", JSON.stringify(response.data.deadline));
										 localStorage.setItem('ur_user_id', JSON.stringify(response.data.user_id));
										 localStorage.setItem('ur_email', JSON.stringify(response.data.email));
										 localStorage.setItem('ur_type', JSON.stringify(response.data.type));
 
										 state.dispatch('redirectUsingRole');
								 }).catch(error => {
								 if (error.response) {
										 state.dispatch('user/checkErrorMessage', error.response, {root: true});
								 }
						 });
				 },*/

		/*  isRemembered: function (state) {

					let self = this;
					let result = 1;
					for (var i = 0; i < state.state.rolesAdmitted.length; i++) {
							if (localStorage.getItem(state.state.rolesAdmitted[i]) == undefined) {
									result = 0;
							}
					}
					if (result === 1) {
							state.dispatch('redirectUsingRole');
					}
			},*/

		/*        checkRealTimeExpiring: function (state) {
								if (localStorage.getItem('ur_type') != 98) // coach
								{
										axios.get('/api/v1/user/checkRealTimeExpiring')
												.then(function (response) {
														if (response.data === -1) {
																state.dispatch('destroyToken');
																state.dispatch('redirectToLogin');
														}
												})
								}
						},*/

		/*        unsubscribe: function(state, token)
						{
								axios.post('/api/v1/user/unsubscribe/', token);
						}*/
	}
}
